import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import SimpleCrypto from "simple-crypto-js";
import config from "../../../baseConfig/index";
import ErrorModal from "../../Fragments/ErrorModal";
import Tab from "../../Fragments/Tab";
import {
  ArmenianFlagConst,
  EyeComponent,
} from "../../UIComponents/UIComponents";

class PrivateClients extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // username: this.props.loginEmail,
      touched: false,
      password: "",
      passwordEmail: "",
      _token: this.props.csrf_token.data,
      buttonDisabled: false,
      formResponse: "",
      showErrorModal: false,
      currentTabIndex: 0,
      isShowPassword: false,
      isShowEmailPassword: false,
    };
  }
  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      isShowPassword: !prevState.isShowPassword,
    }));
  };
  toggleEmailPasswordVisibility = () => {
    this.setState((prevState) => ({
      isShowEmailPassword: !prevState.isShowEmailPassword,
    }));
  };

  handleBlur = () => {
    this.setState({ touched: true });
  };

  validateForm = () => {
    const { currentTabIndex, username, phoneNumber, email } = this.state;
    const numberRegex = /^[1-9]\d{7}$/;
    const regexEmail = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

    if (currentTabIndex === 0) {
      if (!numberRegex.test(phoneNumber)) {
        return false;
      }
    }

    if (currentTabIndex === 1) {
      if (!regexEmail.test(email)) {
        return false;
      }
    }

    return true;
  };

  reSendData() {
    this.setState({ buttonDisabled: true });

    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        this.props.setTokenAction(resolve.data);
        this.setState({ _token: resolve.data.data });
        this.sendData();
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  sendData() {
    this.setState({ buttonDisabled: true });
    let username = this.state.phoneNumber?.replace(/^\+374|^0/g, "");
    let password = this.state.password;
    if (this.state.currentTabIndex == 1) {
      username = this.state.email;
      password = this.state.passwordEmail;
    }
    ApiManager.postRequest(
      {
        username: username,
        password: password,
        _token: this.state._token,
      },
      "/login"
    ).then(
      (resolve) => {
        this.setState({
          buttonDisabled: false,
          formResponse: resolve.data,
        });

        if (resolve.data.status === "OK") {
          const simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
          this.props.cookies.set(
            "loginToken",
            simpleCrypto.encrypt(resolve.data?.data?.accessToken),
            { path: config.urlPrefix }
          );
          if (resolve.data?.data?.refreshToken) {
            this.props.cookies.set(
              "refreshToken",
              simpleCrypto.encrypt(resolve.data?.data?.refreshToken),
              { path: config.urlPrefix }
            );
          }
          this.props.history.push(config.urlPrefix + "profile");
        } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
          this.reSendData();
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    let userNameErrorClass = "",
      userNameErrorBox = "",
      passwordErrorClass = "",
      passwordErrorBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("username")) {
          userNameErrorClass = " form-error";
          userNameErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.username}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("password")) {
          passwordErrorClass = " form-error";
          passwordErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.password}
            </div>
          );
        }
      }

      if (
        this.state.formResponse.status === "ERROR" ||
        this.state.formResponse.status === "NOT_FOUND"
      ) {
        errorBox = (
          <FormMiddlewareError message={this.state.formResponse.message} />
        );
      }
    }

    const numberRegex = /^[1-9]\d{7}$/;
    const regexEmail = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          noValidate
          onSubmit={(event) => {
            event.preventDefault();
            this.setState({ touched: true }, () => {
              if (!this.validateForm()) {
                return;
              }
              this.sendData();
            });
          }}
        >
          <Tab
            items={[
              {
                title: trans(this.props.trans, "auth.number.title"),
                content: (
                  <>
                    <div className={`form__form-box${userNameErrorClass}`}>
                      <label
                        className="form__label db fs11"
                        htmlFor="tel-number"
                      >
                        {trans(this.props.trans, "auth.login.number.label")}
                      </label>
                      <div
                        className="form__field-out pr"
                        style={{ display: "flex" }}
                      >
                        <ArmenianFlagConst />
                        {/* <input
                          type="text"
                          name="fake-user"
                          autoComplete="username"
                          style={{ display: "none" }}
                          onChange={() => {}}
                          value=""
                        /> */}

                        <input
                          className="form__field form__field--right-space fs13"
                          style={{
                            border: "none",
                            borderRadius: "0",
                            borderBottom: "1px solid #ccc",
                          }}
                          onBlur={this.handleBlur}
                          id="tel-number"
                          type="text"
                          placeholder={trans(
                            this.props.trans,
                            "auth.login.number.placeholder"
                          )}
                          onChange={(event) => {
                            this.setState({
                              phoneNumber: event.target.value.trim(),
                            });
                          }}
                          value={this.state.phoneNumber ?? ""}
                        />
                        {/* <div className="form__info-box pa">
                          <span className="form__info sprite db"> </span>
                          <div className="form__info-txt fs11 pa">
                            {trans(this.props.trans, "auth.login.number.hint")}
                          </div>
                        </div> */}
                      </div>
                      {userNameErrorBox}
                      <div
                        className="form-error-text fs11"
                        style={{ marginTop: "5px", color: "red" }}
                      >
                        {this.state.touched &&
                          !numberRegex.test(this.state.phoneNumber) &&
                          trans(
                            this.props.trans,
                            "auth.login.validation.number"
                          )}
                      </div>
                    </div>
                    <div className={`form__form-box${passwordErrorClass}`}>
                      <label
                        className="form__label  db fs11"
                        htmlFor="password"
                      >
                        {trans(this.props.trans, "auth.login.password.label")}
                      </label>
                      <div className="form__field-out pr">
                        <input
                          className="form__field form__field--right-space fs13"
                          id="password"
                          type={this.state.isShowPassword ? "text" : "password"}
                          onBlur={this.handleBlur}
                          placeholder={trans(
                            this.props.trans,
                            "auth.login.password.placeholder"
                          )}
                          onChange={(event) => {
                            this.setState({
                              password: event.target.value.trim(),
                            });
                          }}
                          value={this.state.password ?? ""}
                        />

                        {/* <div className="form__info-box pa">
                          <span className="form__info sprite db"> </span>
                          <div className="form__info-txt fs11 pa">
                            {trans(
                              this.props.trans,
                              "auth.login.password.hint"
                            )}
                          </div>
                        </div> */}
                        <EyeComponent
                          isShow={this.state.isShowPassword}
                          eyeHandler={this.togglePasswordVisibility}
                        />
                      </div>

                      {passwordErrorBox}
                    </div>
                  </>
                ),
                clickCallback: () => this.setState({ currentTabIndex: 0 }),
              },
              {
                title: trans(this.props.trans, "auth.email.title"),
                content: (
                  <>
                    <div className={`form__form-box${userNameErrorClass}`}>
                      <label
                        className="form__label db fs11"
                        htmlFor="tel-number"
                      >
                        {trans(this.props.trans, "auth.login.number.label")}
                      </label>
                      <div className="form__field-out pr">
                        <input
                          className="form__field form__field--right-space fs13"
                          id="email"
                          type="email"
                          placeholder={trans(
                            this.props.trans,
                            "auth.login.email.placeholder"
                          )}
                          onBlur={this.handleBlur}
                          onChange={(event) => {
                            this.setState({
                              email: event.target.value.trim(),
                            });
                          }}
                          value={this.state.email ?? ""}
                        />
                        {/* <div className="form__info-box pa">
                          <span className="form__info sprite db"> </span>
                          <div className="form__info-txt fs11 pa">
                            {trans(this.props.trans, "auth.login.number.hint")}
                          </div>
                        </div> */}
                      </div>
                      {userNameErrorBox}
                      <div
                        className="form-error-text fs11"
                        style={{ marginTop: "5px", color: "red" }}
                      >
                        {this.state.touched &&
                          !regexEmail.test(this.state.email) &&
                          trans(
                            this.props.trans,
                            "auth.login.validation.email"
                          )}
                      </div>
                    </div>
                    <div className={`form__form-box${passwordErrorClass}`}>
                      <label
                        className="form__label  db fs11"
                        htmlFor="passwordEmail"
                      >
                        {trans(this.props.trans, "auth.login.password.label")}
                      </label>
                      <div className="form__field-out pr">
                        <input
                          className="form__field form__field--right-space fs13"
                          id="passwordEmail"
                          type={
                            this.state.isShowEmailPassword ? "text" : "password"
                          }
                          placeholder={trans(
                            this.props.trans,
                            "auth.login.password.placeholder"
                          )}
                          onChange={(event) => {
                            this.setState({
                              passwordEmail: event.target.value.trim(),
                            });
                          }}
                          value={this.state.passwordEmail ?? ""}
                        />
                        <EyeComponent
                          isShow={this.state.isShowEmailPassword}
                          eyeHandler={this.toggleEmailPasswordVisibility}
                        />
                        {/* <div className="form__info-box pa">
                          <span className="form__info sprite db"> </span>
                          <div className="form__info-txt fs11 pa">
                            {trans(
                              this.props.trans,
                              "auth.login.password.hint"
                            )}
                          </div>
                        </div> */}
                      </div>
                      {passwordErrorBox}
                    </div>
                  </>
                ),
                clickCallback: () => this.setState({ currentTabIndex: 1 }),
              },
            ]}
            index={
              window.location.hash.replace("#", "") === "b2b"
                ? 1
                : this.props.tabIndex
            }
          />

          {errorBox}

          <button
            className={`form__submit-btn btn btn--with-space btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={this.state.buttonDisabled}
          >
            {trans(this.props.trans, "auth.login.button.title")}
          </button>

          <Link
            className="form__link form__link--with-space fs13 db tc"
            to={config.urlPrefix + `forgot-password-b2c`}
          >
            {trans(this.props.trans, "auth.login.forgot_password.title")}
          </Link>

          <Link
            className="form__registration-btn btn btn--white db fs17"
            to={config.urlPrefix + `register`}
          >
            {trans(this.props.trans, "auth.login.register.button.title")}
          </Link>
        </form>

        {this.errorModal()}
      </div>
    );
  }
}

export default withRouter(withCookies(PrivateClients));
